import { render, staticRenderFns } from "./AdminSubjects.vue?vue&type=template&id=11a47626"
import script from "./AdminSubjects.vue?vue&type=script&lang=js"
export * from "./AdminSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports